<template>
  <path
    d="M8.70999 11.7102L11.3 14.3002C11.69 14.6902 12.32 14.6902 12.71 14.3002L15.3 11.7102C15.93 11.0802 15.48 10.0002 14.59 10.0002H9.40999C8.51999 10.0002 8.07999 11.0802 8.70999 11.7102Z"
  />
</template>
